import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { CoreGoogleAnalyticActions } from '../analytic';
import { fromEvent, tap } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UAParser } from 'ua-parser-js';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class PwaService {
  #parser = new UAParser();
  #store: Store = inject(Store);

  init() {
    // remove prev sub and  subscribe to install prompt
    const evt = fromEvent(window, 'appinstalled').pipe(
      untilDestroyed(this),
      tap((event: Event) => {
        const device = this.#parser.getDevice();
        const deviceType =
          window.innerWidth < 768
            ? 'mobile'
            : window.innerWidth < 1024
              ? 'tablet'
              : 'desktop';
        this.#store.dispatch(
          CoreGoogleAnalyticActions.trackEvent({
            event: {
              event: 'user_load_app',
              pwa: device.type || deviceType,
              pwa_install: true,
            },
          }),
        );
      }),
    );

    evt.subscribe();
  }
}
